import { isValidElement } from "react";
import { useSmOrMdScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import { LeftPanel } from "./components/LeftPanel";
import { RightPanel } from "./components/RightPanel";
import { Testimonials } from "./components/Testimonials";
import type { OnboardingSplitLayoutProps } from "./types";

export const OnboardingSplitLayout = ({
  children,
  rightPanel,
  progress,
  title,
  subtitle,
}: OnboardingSplitLayoutProps) => {
  const isSmScreen = useSmOrMdScreenMediaQuery();

  const isTestimonials =
    isValidElement(rightPanel) && rightPanel.type === Testimonials;

  return (
    <div className="flex min-h-screen w-full">
      <LeftPanel progress={progress} title={title} subtitle={subtitle}>
        {children}
      </LeftPanel>

      {!isSmScreen && (
        <RightPanel fullWidthChild={isTestimonials}>{rightPanel}</RightPanel>
      )}
    </div>
  );
};
